/* Cool Change Co: drawers, announcement bar, sticky header, menus, predictive search. */
(function () {
  if (window.CCDrawer) return;
  var html = document.documentElement;
  var openStack = [];
  var lastFocus = null;

  function focusables(el) {
    return Array.prototype.filter.call(el.querySelectorAll('a[href],button:not([disabled]),input:not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])'), function (n) { return n.offsetParent !== null || n === document.activeElement; });
  }

  var CCDrawer = {
    open: function (id) {
      var d = document.getElementById(id);
      if (!d || d.classList.contains('is-open')) return d;
      openStack.forEach(function (o) { if (o !== d) CCDrawer.close(o.id, true); });
      lastFocus = document.activeElement;
      d.classList.add('is-open');
      openStack = [d];
      html.classList.add('cc-lock');
      document.querySelectorAll('[data-cc-open="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      setTimeout(function () {
        var want = d.getAttribute('data-cc-focus');
        var f = want ? d.querySelector(want) : null;
        (f || d.querySelector('.cc-drawer__panel')).focus({ preventScroll: true });
      }, 80);
      d.dispatchEvent(new CustomEvent('cc:open', { bubbles: true }));
      return d;
    },
    close: function (id, silent) {
      var d = document.getElementById(id);
      if (!d || !d.classList.contains('is-open')) return;
      d.classList.remove('is-open');
      openStack = openStack.filter(function (o) { return o !== d; });
      if (!openStack.length) html.classList.remove('cc-lock');
      document.querySelectorAll('[data-cc-open="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      d.dispatchEvent(new CustomEvent('cc:close', { bubbles: true }));
      if (!silent && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    },
    closeAll: function () { openStack.slice().forEach(function (d) { CCDrawer.close(d.id); }); }
  };
  window.CCDrawer = CCDrawer;

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cc-open]');
    if (opener) {
      var id = opener.getAttribute('data-cc-open');
      if (document.getElementById(id)) { e.preventDefault(); CCDrawer.open(id); }
      return;
    }
    var closer = e.target.closest('[data-cc-close]');
    if (closer) { var dr = closer.closest('[data-cc-drawer]'); if (dr) CCDrawer.close(dr.id); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { CCDrawer.closeAll(); closeMenus(); return; }
    if (e.key !== 'Tab' || !openStack.length) return;
    var f = focusables(openStack[openStack.length - 1]);
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* swipe down to close bottom sheets (phones) */
  function bindSwipe(d) {
    var panel = d.querySelector('.cc-drawer__panel');
    if (!panel || d.classList.contains('cc-cart')) return;
    var startY = 0, dy = 0, active = false;
    panel.addEventListener('touchstart', function (e) {
      if (window.innerWidth >= 640) return;
      var sc = e.target.closest('.cc-mm__scroll, .cc-mm > .cc-mm__list, .cc-search__body, .cc-cart__body, .cc-facets__body');
      var onHandle = e.target.closest('[data-cc-swipe]');
      if (!onHandle && sc && sc.scrollTop > 0) return;
      startY = e.touches[0].clientY; dy = 0; active = true;
    }, { passive: true });
    panel.addEventListener('touchmove', function (e) {
      if (!active) return;
      dy = e.touches[0].clientY - startY;
      if (dy <= 0) { panel.style.transform = ''; d.classList.remove('is-dragging'); return; }
      d.classList.add('is-dragging');
      panel.style.transform = 'translate3d(0,' + dy + 'px,0)';
    }, { passive: true });
    panel.addEventListener('touchend', function () {
      if (!active) return;
      active = false;
      d.classList.remove('is-dragging');
      panel.style.transform = '';
      if (dy > 110) CCDrawer.close(d.id);
    });
  }

  /* announcement bar */
  function initAnn(bar) {
    if (bar.dataset.ccReady) return;
    bar.dataset.ccReady = '1';
    var slides = bar.querySelectorAll('[data-cc-ann-slide]');
    if (slides.length < 2) return;
    var i = 0, timer = null, speed = (parseInt(bar.dataset.speed, 10) || 5) * 1000;
    function go(n) {
      var cur = slides[i];
      i = (n + slides.length) % slides.length;
      cur.classList.remove('is-active');
      cur.classList.add('is-leaving');
      cur.setAttribute('aria-hidden', 'true');
      setTimeout(function () { cur.classList.remove('is-leaving'); }, 700);
      slides[i].classList.add('is-active');
      slides[i].removeAttribute('aria-hidden');
    }
    function play() { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, speed); }
    var prev = bar.querySelector('[data-cc-ann-prev]'), next = bar.querySelector('[data-cc-ann-next]');
    if (prev) prev.addEventListener('click', function () { go(i - 1); play(); });
    if (next) next.addEventListener('click', function () { go(i + 1); play(); });
    var sx = 0;
    bar.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    bar.addEventListener('touchend', function (e) { var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) { go(dx < 0 ? i + 1 : i - 1); play(); } });
    bar.addEventListener('mouseenter', function () { clearInterval(timer); });
    bar.addEventListener('mouseleave', play);
    play();
  }

  /* sticky header shrink */
  var head = null;
  function onScroll() {
    if (!head) return;
    var limit = head.offsetHeight + 48;
    var y = window.scrollY || html.scrollTop;
    head.classList.toggle('is-scrolled', y > limit);
    if (y > limit * 2 && head.classList.contains('is-open')) closeMenus();
  }

  /* desktop menus */
  var overlay = null, openItem = null, closeT = null;
  function openMenu(li) {
    clearTimeout(closeT);
    if (openItem === li) return;
    if (openItem) openItem.classList.remove('is-open');
    openItem = li;
    li.classList.add('is-open');
    var a = li.querySelector('.cc-nav__link'); if (a) a.setAttribute('aria-expanded', 'true');
    if (head) head.classList.add('is-open');
    if (overlay) overlay.classList.add('is-on');
  }
  function closeMenus() {
    if (!openItem) return;
    var a = openItem.querySelector('.cc-nav__link'); if (a) a.setAttribute('aria-expanded', 'false');
    openItem.classList.remove('is-open');
    openItem = null;
    if (head) head.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-on');
  }
  function initNav(root) {
    overlay = root.querySelector('[data-cc-head-overlay]') || document.querySelector('[data-cc-head-overlay]');
    root.querySelectorAll('[data-cc-dd]').forEach(function (li) {
      var link = li.querySelector('.cc-nav__link');
      li.addEventListener('mouseenter', function () { if (window.matchMedia('(hover: hover)').matches) openMenu(li); });
      li.addEventListener('mouseleave', function () { closeT = setTimeout(closeMenus, 120); });
      link.addEventListener('click', function (e) {
        if (window.matchMedia('(hover: hover)').matches) return;
        if (openItem !== li) { e.preventDefault(); openMenu(li); }
      });
      li.addEventListener('focusout', function (e) { if (!li.contains(e.relatedTarget)) closeT = setTimeout(closeMenus, 120); });
      link.addEventListener('keydown', function (e) { if (e.key === 'ArrowDown') { e.preventDefault(); openMenu(li); var f = li.querySelector('[data-cc-panel] a, [data-cc-panel] button'); if (f) f.focus(); } });
      li.querySelectorAll('[data-cc-tab]').forEach(function (tab) {
        function show() {
          li.querySelectorAll('[data-cc-tab]').forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
          li.querySelectorAll('[data-cc-tabpanel]').forEach(function (p) { p.hidden = p.getAttribute('data-cc-tabpanel') !== tab.getAttribute('data-cc-tab'); });
        }
        tab.addEventListener('click', show);
        tab.addEventListener('mouseenter', show);
      });
    });
    if (overlay) overlay.addEventListener('click', closeMenus);
  }

  /* phone menu: slide-in panels */
  function initMobileMenu(menu) {
    menu.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-cc-sub]');
      if (opener) {
        var panel = document.getElementById(opener.getAttribute('data-cc-sub'));
        if (!panel) return;
        var list = opener.closest('[data-cc-mm-list]');
        if (list) list.classList.add('is-pushed');
        panel.classList.add('is-active');
        var back = panel.querySelector('[data-cc-back]'); if (back) setTimeout(function () { back.focus({ preventScroll: true }); }, 60);
        return;
      }
      var back2 = e.target.closest('[data-cc-back]');
      if (back2) {
        var p = back2.closest('[data-cc-subpanel]');
        p.classList.remove('is-active');
        var parentList = p.parentNode.closest('[data-cc-mm-list]');
        if (parentList) parentList.classList.remove('is-pushed');
      }
    });
    var drawer = menu.closest('[data-cc-drawer]');
    if (drawer) drawer.addEventListener('cc:close', function () {
      setTimeout(function () {
        menu.querySelectorAll('.is-active').forEach(function (p) { p.classList.remove('is-active'); });
        menu.querySelectorAll('.is-pushed').forEach(function (l) { l.classList.remove('is-pushed'); });
      }, 600);
    });
  }

  /* predictive search */
  function initSearch(form) {
    var input = form.querySelector('[data-cc-search-input]');
    var results = form.querySelector('[data-cc-search-results]');
    var wrap = form.closest('.cc-search');
    var t = null, ctrl = null;
    function setQ() { wrap.classList.toggle('has-q', input.value.trim().length > 0); }
    function clear() { results.innerHTML = ''; wrap.classList.remove('has-results'); }
    input.addEventListener('input', function () {
      setQ();
      clearTimeout(t);
      var q = input.value.trim();
      if (!q) { clear(); return; }
      t = setTimeout(function () {
        if (ctrl) ctrl.abort();
        ctrl = window.AbortController ? new AbortController() : null;
        wrap.classList.add('is-loading');
        var url = form.getAttribute('data-url') + '?q=' + encodeURIComponent(q) + '&resources[type]=query,product,collection,page&resources[limit]=3&resources[limit_scope]=each&section_id=cc-predictive-search';
        fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.text(); }).then(function (txt) {
          var doc = new DOMParser().parseFromString(txt, 'text/html');
          var sec = doc.querySelector('.shopify-section') || doc.body;
          results.innerHTML = sec.innerHTML;
          wrap.classList.toggle('has-results', !!results.querySelector('.cc-sr'));
        }).catch(function () {}).then(function () { wrap.classList.remove('is-loading'); });
      }, 300);
    });
    form.addEventListener('reset', function () { setTimeout(function () { setQ(); clear(); input.focus(); }, 0); });
  }

  function init() {
    document.querySelectorAll('[data-cc-drawer]').forEach(function (d) { if (!d.dataset.ccSwipe) { d.dataset.ccSwipe = '1'; bindSwipe(d); } });
    document.querySelectorAll('[data-cc-ann]').forEach(initAnn);
    head = document.querySelector('[data-cc-head]');
    if (head && !head.dataset.ccReady) {
      head.dataset.ccReady = '1';
      initNav(document);
      var mm = document.querySelector('[data-cc-mm]'); if (mm) initMobileMenu(mm);
      var sf = document.querySelector('[data-cc-search]'); if (sf) initSearch(sf);
      window.addEventListener('scroll', function () { window.requestAnimationFrame(onScroll); }, { passive: true });
      onScroll();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { head = null; init(); });
})();
